/**
 * Arrays utility
 */
export abstract class ArraysUtil {
  /**
   * Checks if 2 arrays are equal by comparing their sitringified JSONs. Attention: Sorting matters!
   * @param arr1 First array
   * @param arr2 2nd array
   * @returns true if they are equal
   */
  public static arraysEqual(arr1: any[], arr2: any[]): boolean {
    return JSON.stringify(arr1 || []) === JSON.stringify(arr2 || []);
  }
}
